<mat-toolbar color="warn" style="background-color: #36454F	;position: fixed;z-index: 99;">
  <div>
    <!-- <button mat-icon-button [matMenuTriggerFor]="menu" >
      <mat-icon>more_vert</mat-icon>
    </button> -->
    <fa-icon  mat-icon-button [matMenuTriggerFor]="menu" [icon]="faGaugeHigh" s style=" cursor: pointer; color: white;" class="fa-1x"></fa-icon>&nbsp;
    <mat-menu #menu="matMenu">
      <button mat-menu-item>

        <fa-icon  [icon]="faGaugeSimpleHigh"  style=" cursor: pointer;" class="fa-1x" ></fa-icon>
        <span> <a mat-button [routerLink]="['/Home']">Student Detail Dashboard</a></span>
      </button>
      <button mat-menu-item>

        <fa-icon  [icon]="faPerson"  style=" cursor: pointer;" class="fa-1x" ></fa-icon>
        <span> <a mat-button [routerLink]="['/StudentDetail']">Student Detail</a></span>
      </button>
      <button mat-menu-item>

        <fa-icon  [icon]="faGaugeHigh"  style=" cursor: pointer;" class="fa-1x" ></fa-icon>
        <span> <a mat-button href="https://thedistrict.yisd.net/YISDAttendanceMeter/Dashboard.aspx#/" target="_blank">District Dashboard</a></span>
      </button>
    </mat-menu>
  </div>
  <a class="title" href="/" style="text-decoration: none">
      {{ title }}
  </a>

  <div class="toolbar-spacer"></div>
  <div *ngIf="User" style="padding-right: 20px;">
    <select class="form-select" [(ngModel)]="selected" name="status" placeholder="select" (ngModelChange)="onLocSelected($event)" >
      <option *ngFor="let loc of User.lstLocations" [ngValue]="loc">{{loc.description}}</option>
    </select>
  </div>
  <!-- <a mat-button [routerLink]="['profile']">Profile</a> -->
  <a style="padding-right: 20px; font-size: 15px;" >{{User.fullName}}</a>


  <!-- <button mat-raised-button *ngIf="!loginDisplay" style="color: white;"  type="button" class="btn btn-link" (click)="login()"> -->
    <fa-icon *ngIf="!loginDisplay" [icon]="faArrowRightFromBracket" s style=" cursor: pointer; color: white;" class="fa-1x" (click)="login()"></fa-icon>
  <!-- </button> -->
  <!-- <button mat-raised-button *ngIf="loginDisplay"  style="color: white;"  type="button" class="btn btn-link" (click)="logout()"> -->
      <fa-icon *ngIf="loginDisplay" [icon]="faArrowRightFromBracket" s style=" cursor: pointer; color: white;" class="fa-1x" (click)="logout()"></fa-icon>
  <!-- </button> -->
</mat-toolbar>
<div class="centerContainer" style="padding-bottom: 2%;">

  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
